import { Controller } from "@hotwired/stimulus";

// This replicates the validation in HasSlug. We need to manually
// keep the rules in sync.
export default class extends Controller {
  static values = {
    liquid: { type: Boolean, default: false },
    ruby: { type: Boolean, default: false },
  };

  connect() {
    this.inputField = this.element.querySelector("input");
    this.inputField.addEventListener("input", this.handler.bind(this));
    this.inputField.addEventListener("change", this.handler.bind(this));
    this.slugValue = this.element.querySelector("slug-value");
    this.hint = this.element.querySelector(".hint");
  }

  disconnect() {
    this.inputField.removeEventListener("input", this.handler);
    this.inputField.removeEventListener("change", this.handler);
    this.clearTimeout();
  }

  handler(e) {
    const origValue = e.target.value;
    let value = origValue;

    if (this.rubyValue) {
      // Ruby identifiers: only letters, numbers, and underscores
      value = value.replace(/[^a-z0-9_]/gi, "_");
    } else {
      // Letters, numbers, underscores, and hyphens
      value = value.replace(/[^a-z0-9\-_]/gi, "-");
    }

    if (this.liquidValue || this.rubyValue) {
      // This will add an underscore prefix if the
      // value doesn't start with a letter or underscore
      // e.g. "1abc" -> "_1abc"
      value = value.replace(/^[^a-z_]/i, "_$&");
    }

    // Apply the changes
    e.target.value = value;

    // If the value was changed then highlight the rules in the hint
    // for a second.
    if (value != origValue) {
      this.hint.classList.add("reminder");
      this.clearTimeout();
      this.timeout = setTimeout(() => {
        this.hint.classList.remove("reminder");
      }, 1000);
    }

    // Update the preview of the URL if there is one
    if (this.slugValue) {
      this.slugValue.innerText = value;
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
